import assetPath from '/app/packages/lebenslauf/articles/src/assets/das-perfekte-bewerbungsschreiben-au.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')